// Page copy shared with the server-rendered pages: public/content/<name>.json is
// read here and by the backend's services/seo_render_service.py, so the HTML
// crawlers read and the page people see say the same words.
import { useEffect, useState } from 'react';

const cache = new Map();

/** The parsed file, fetched once per page load (null if it cannot be read). */
export function loadContent(name) {
  if (!cache.has(name)) {
    const request = fetch(`/content/${name}.json`)
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null)
      .then((data) => {
        if (!data) cache.delete(name); // let a later visit try again
        return data;
      });
    cache.set(name, request);
  }
  return cache.get(name);
}

/** The file's content, or null until it has loaded. */
export function useContent(name) {
  const [content, setContent] = useState(null);
  useEffect(() => {
    let active = true;
    loadContent(name).then((data) => {
      if (active) setContent(data);
    });
    return () => {
      active = false;
    };
  }, [name]);
  return content;
}
